/**
 * 巡检任务监控 · 异常处理看板 — POST /api/produce/kanban/inspection-task-monitor
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/inspection-task-monitor'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchInspectionTaskMonitor(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
